import { createContext, useContext, useMemo } from 'react';
// @ts-expect-error Untyped
import connectDnd from 'ui-addon-draggable/decorators/connectDnd';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
const noopFalse = () => false;
const noopTrue = () => true;
const DragDropContext = /*#__PURE__*/createContext({
  hasDragDrop: false,
  onDndDrop: noop,
  onDndHover: noop,
  canDrop: noopFalse,
  dragGroup: ''
});
const InternalProvider = ({
  dragGroup,
  onDndDrop,
  onDndHover,
  canDrop,
  children
}) => {
  const contextValue = useMemo(() => {
    const hasDragDrop = !!(onDndDrop || onDndHover);
    return {
      dragGroup: dragGroup !== null && dragGroup !== void 0 ? dragGroup : '',
      onDndDrop: onDndDrop !== null && onDndDrop !== void 0 ? onDndDrop : noop,
      onDndHover: onDndHover !== null && onDndHover !== void 0 ? onDndHover : noop,
      canDrop: hasDragDrop ? canDrop !== null && canDrop !== void 0 ? canDrop : noopTrue : noopFalse,
      hasDragDrop
    };
  }, [dragGroup, onDndDrop, onDndHover, canDrop]);
  const TypedProvider = DragDropContext.Provider;
  return /*#__PURE__*/_jsx(TypedProvider, {
    value: contextValue,
    children: children
  });
};
export const UICalendarDragDropProvider = connectDnd(InternalProvider);
export const useDragDrop = () => {
  const state = useContext(DragDropContext);
  return state;
};